module.exports = __webpack_public_path__ + "static/media/Anleitung_Export_Import_Flaechen_LAT.787365db.pdf";